import React from "react";
import { IconPlus } from "@velaro/velaro-component-lib";
import {
  SecondaryGrayButton,
  TertiaryGrayButton
} from "@velaro/velaro-component-lib";
import { ConditionBlock } from "./ConditionBlock";
import { Expression, ExpressionType, SerializedCondition } from "./types";

interface Props {
  expressionType: ExpressionType;
  expression: Expression;
  onUpdate(expression: Expression): void;
}
export function ExpressionEditor({
  expressionType,
  expression,
  onUpdate
}: Props) {
  function addOrCondition() {
    const clone = expression ? [...expression] : [];
    clone.push([
      {
        type: "",
        data: "{}"
      }
    ]);
    onUpdate(clone);
  }

  function addAndCondition(i: number) {
    const andBlock = expression[i];
    andBlock.push({
      type: "",
      data: "{}"
    });
    onUpdate([...expression]);
  }

  function updateCondition(
    condition: SerializedCondition,
    i: number,
    j: number
  ) {
    const clone = expression ? [...expression] : [];
    clone[i][j] = condition;
    onUpdate(clone);
  }

  function removeCondition(i: number, j: number) {
    const clone = [...expression];
    const andBlock = clone[i];
    andBlock.splice(j, 1);
    if (andBlock.length === 0) {
      clone.splice(i, 1);
    }
    onUpdate(clone);
  }

  function renderAndBlock(conditions: SerializedCondition[], i: number) {
    return (
      <React.Fragment key={i}>
        <div className="rounded-lg bg-slate-gray-100 p-4 flex flex-col">
          <>{conditions.map((c, j) => renderCondition(c, i, j))}</>
          <TertiaryGrayButton
            label="AND — add condition to this group"
            prefixIcon={<IconPlus />}
            onClick={() => addAndCondition(i)}
            className="w-full"
          />
        </div>
        <Divider text="OR" />
      </React.Fragment>
    );
  }

  function renderCondition(
    condition: SerializedCondition,
    i: number,
    j: number
  ) {
    return (
      <React.Fragment key={j}>
        <ConditionBlock
          expressionType={expressionType}
          condition={condition}
          onUpdate={(c) => updateCondition(c, i, j)}
          onRemove={() => removeCondition(i, j)}
        />
        <Divider text="AND" />
      </React.Fragment>
    );
  }

  const hasConditions = expression && expression.length > 0;

  return (
    <>
      {hasConditions && (
        <>{expression.map(renderAndBlock)}</>
      )}
      <SecondaryGrayButton
        label={hasConditions ? "OR — add a new condition group" : "Add Condition"}
        prefixIcon={<IconPlus />}
        onClick={addOrCondition}
        className="w-full"
      />
      {hasConditions && (
        <p className="text-[11px] text-slate-400 mt-1 text-center">
          Conditions in the same group must ALL match (AND). Different groups are alternatives (OR).
        </p>
      )}
    </>
  );
}

function Divider({ text }: { text: string }) {
  return (
    <div className="flex items-center gap-2 my-2">
      <div className="grow border border-slate-300"></div>
      <div className={`text-center text-xs font-bold px-2 py-0.5 rounded ${text === "OR" ? "bg-amber-100 text-amber-700" : "bg-blue-100 text-blue-700"}`}>{text}</div>
      <div className="grow border border-slate-300"></div>
    </div>
  );
}
